// app/shared/services_and_hooks/activationService.ts
import { UserActivationStatus } from '@/app/features/user-profile/userProfile.interface';

/**
 * Service for checking user activation status
 * Step 1 of the Blueprint API data fetching pattern
 */
export const activationService = {
  /**
   * Fetch the user's activation status
   */
  async getActivationStatus(): Promise<UserActivationStatus> {
    const response = await fetch('/api/user/activation-status', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
      console.error('[activationService] Failed to fetch activation status:', errorData);
      throw new Error(errorData.error || 'Failed to fetch activation status');
    }

    return response.json();
  },

  /**
   * Dismiss the activation prompt for 7 days
   */
  async dismissActivationPrompt(): Promise<void> {
    const response = await fetch('/api/user/activation-status/dismiss', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to dismiss activation prompt');
    }
  },

  /**
   * Trigger activation complete check - sends welcome newsletter if qualified
   * Returns information about whether newsletter was sent
   */
  async triggerActivationComplete(): Promise<{
    success: boolean;
    message?: string;
    sent?: boolean;
    alreadySent?: boolean;
    sentAt?: string;
  }> {
    const response = await fetch('/api/user/activation-complete', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
      console.error('[activationService] Failed to trigger activation complete:', errorData);
      throw new Error(errorData.error || 'Failed to trigger activation complete');
    }

    return response.json();
  },
};

